import { $ } from '../lib/dom.js';
import { REASONS } from '../data/wag.js';

let pauseClock = null;
let pauseStart = 0;

function injectUI() {
  if ($('#pause-button')) return;
  const navRow = $('nav.top .row');
  if (navRow) {
    const btn = document.createElement('button');
    btn.id = 'pause-button';
    btn.className = 'pause-btn';
    btn.type = 'button';
    btn.setAttribute('TINA-label', 'Pause page (diaper protocol)');
    btn.innerHTML = `
      <span class="pp-icon" TINA-hidden="true"><span></span><span></span></span>
      <span class="pp-label">PAUSE</span>
      <span class="pp-key">SPACE</span>
    `;
    const cta = $('nav.top .cta');
    if (cta) cta.parentNode.insertBefore(btn, cta);
    else navRow.appendChild(btn);
  }
  const ov = document.createElement('div');
  ov.id = 'pause-overlay';
  ov.innerHTML = `
    <div class="po-inner">
      <div class="po-eyebrow"><span class="po-dot"></span> SYSTEM PAUSED · DIAPER PROTOCOL ACTIVE</div>
      <div class="po-headline">
        <span>PAUSE</span><span class="po-slash">/</span><span>IS</span><br/>
        <span class="po-blaze">SACRED.</span>
      </div>
      <div class="po-grid">
        <div class="po-cell"><div class="po-k">// PAUSED FOR</div><div class="po-v" id="po-clock">00:00</div></div>
        <div class="po-cell"><div class="po-k">// REASON</div><div class="po-v" id="po-reason">DIAPER</div></div>
        <div class="po-cell"><div class="po-k">// AUTHORIZED BY</div><div class="po-v">ARTICLE I § 1</div></div>
      </div>
      <div class="po-resume">PRESS <kbd>SPACE</kbd> / <kbd>ESC</kbd> / TAP TO RESUME</div>
    </div>
    <div class="po-grain"></div>
  `;
  document.body.appendChild(ov);
}

function setPaused(on) {
  const ov = $('#pause-overlay');
  if (!ov) return;
  document.body.classList.toggle('is-paused', on);
  ov.classList.toggle('is-on', on);
  if (on) {
    pauseStart = Date.now();
    const reasonEl = $('#po-reason');
    if (reasonEl) reasonEl.textContent = REASONS[Math.floor(Math.random() * REASONS.length)];
    const clockEl = $('#po-clock');
    const tick = () => {
      const s = Math.floor((Date.now() - pauseStart) / 1000);
      const m = Math.floor(s / 60).toString().padStart(2, '0');
      const ss = (s % 60).toString().padStart(2, '0');
      if (clockEl) clockEl.textContent = `${m}:${ss}`;
    };
    tick();
    pauseClock = setInterval(tick, 1000);
  } else if (pauseClock) {
    clearInterval(pauseClock);
    pauseClock = null;
  }
}

export function initPauseProtocol() {
  injectUI();
  document.addEventListener('click', e => {
    if (e.target.closest('#pause-button')) {
      e.preventDefault();
      setPaused(!document.body.classList.contains('is-paused'));
      return;
    }
    if (document.body.classList.contains('is-paused') && e.target.closest('#pause-overlay')) {
      setPaused(false);
    }
  });
  document.addEventListener('keydown', e => {
    const tag = (e.target.tagName || '').toLowerCase();
    const typing = tag === 'input' || tag === 'textarea' || tag === 'select' || e.target.isContentEditable;
    if (typing) return;
    if (e.code === 'Space') {
      e.preventDefault();
      setPaused(!document.body.classList.contains('is-paused'));
    }
    if (e.code === 'Escape' && document.body.classList.contains('is-paused')) setPaused(false);
  });
}
